import React from "react";
import Heading from "../../components/Heading";
import IconButton from "../../components/IconButton";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import SelectArticle from "./Progress/SelectArticle";
import UploadTemplates from "./Progress/UploadTemplates";
import DefineAreas from "./Progress/DefineAreas";
import DetermineSurchargeType from "./Progress/DetermineSurchargeType";
import NavButtons from "./Progress/NavButtons";
import {useIndividualizationContext} from "../../contexts/individualizationContext";
import {useTranslation} from "react-i18next";
import ProgressBar from "./Progress/ProgressBar";
import ErrorBar from "./Progress/ErrorBar";

const DuplicateIndividualization: React.FC = () => {
    const {currentTab, changeCurrentTab} = useIndividualizationContext()
    const { t } = useTranslation(['individualization'])

    return currentTab === 4 ? (
        <div>
            <Heading level={2} classes={'mt-4'}>{t('headings.duplicate')}</Heading>
            <div className={'mb-4'}>
                <IconButton
                    icon={faArrowLeft}
                    color={'black'}
                    onClick={() => changeCurrentTab(1)}
                >
                    {t('common.backToOverview')}
                </IconButton>
            </div>
            <ProgressBar/>
            <ErrorBar/>
            <SelectArticle/>
            <UploadTemplates/>
            <DefineAreas/>
            <DetermineSurchargeType/>
            <NavButtons method={"duplicate"}/>
        </div>
    ): null
}
export default DuplicateIndividualization
